import classnames from 'classnames';
import React, { useState } from 'react';

import { formatAccountNumber, sanitizeAccountNumber } from '@eika-infrastruktur/format';

import { Account } from '../../../../generated-types';
import { currencyFormatter } from '../../../shared/numberFormat';
import { isUnknownAccount } from '../../../transaction/Transfer/hooks/useToAccount';

import './FromAccountSelect.scss';

interface Props {
    id: string;
    showNegativeAmount: boolean;
    item: Account;
}

const AccountListItem = ({ id, showNegativeAmount, item }: Props) => {
    const [shake, setShake] = useState(false);
    return (
        <li id={`selected-${id}-${sanitizeAccountNumber(item.accountNumber.value)}`}>
            <div
                onKeyDown={() => {}}
                onClick={() => setShake(true)}
                onAnimationEnd={() => setShake(false)}
                className="from-account-select__list-item"
            >
                <button
                    type="button"
                    className={classnames('from-account-select__list-item-button inactive', {
                        'select__list-item-button-shake': shake,
                    })}
                    onClick={() => setShake(true)}
                    onAnimationEnd={() => setShake(false)}
                >
                    <span className="from-account-select__list-item-left-text">{item.alias}</span>
                    <span className="from-account-select__list-item-left-sub-text" data-testid="from-account-numbers">
                        {formatAccountNumber(item.accountNumber)}
                    </span>
                    <span className="from-account-select__list-item-right-text" data-testid="from-account-balances">
                        {!isUnknownAccount(item) &&
                            currencyFormatter(
                                showNegativeAmount ? item.balance.accountingBalance : item.balance.availableBalance,
                                item.currency,
                            )}
                    </span>
                </button>
            </div>
        </li>
    );
};

export default AccountListItem;
